export default "__VITE_ASSET__BtjDHEWR__"